
import { defineComponent, computed } from 'vue-demi';
import { useRoute, useRouter } from '@/router/use-router';
import accountStore from '@/store/modules/account';
import { logout } from '@/utils/authUtil';
import { showToast } from '../../utils/msgUtil';
import i18n from '@/i18n';

const name = 'PromoteRevalidation';
export default defineComponent({
  name,
  components: {
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    }
  },
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const { aadvid } = route.value.query;
    const isNeedModal = computed(() => route.value.name !== 'setting');
    const handleClick = () => {
      const shareData = {
        title: i18n.t('module_campaign_source_ttam') as string,
        text: "",
        url: `https://ads.tiktok.com/i18n/login?enter_from=ttba_promote&redirect=https%3A%2F%2Fads.tiktok.com%2Fi18n%2Faccount%2Fcomplete%3Faadvid%3D${aadvid}`,
      };
      try {
        if (!navigator.share) {
          navigator?.clipboard?.writeText(`https://ads.tiktok.com/i18n/login?enter_from=ttba_promote&redirect=https%3A%2F%2Fads.tiktok.com%2Fi18n%2Faccount%2Fcomplete%3Faadvid%3D${aadvid}`);
          showToast({
            message: i18n.t('fastceation_moreobj_copy_success') as string,
            type: 'success'
          });
          showToast({
            message: i18n.t('fastceation_moreobj_copy_success') as string,
            type: 'success'
          });
        } else {
          navigator.share(shareData)
            .catch(err => {
            console.log(err)
          });
        }
      } catch (e) {
        console.log(e)
      }
    }

    const handleClose = () => {
      if(accountStore.state.allAccountList.length > 1) {
        if (!['home', 'setting'].includes(route.value.name)) {
          router.push({ name: 'home' });
          return;
        }
        emit('update:value', false);
      } else {
        logout();
        return;
      }
    }

    return {
      handleClick,
      handleClose,
      isNeedModal
    };
  },
});


